import { PUBLIC_FILE_PATH } from '../constants';
import { FileVariantsEnum, filterEmptyValues } from '@sweatpals/shared';

type PublicFileUrlParams = {
	quality?: number;
	width?: number;
} | {
	variant: FileVariantsEnum;
};

export const getPublicFileQueryParams = (params?: PublicFileUrlParams): string => {
	const res: Record<string, string> = filterEmptyValues({
		q: (params && 'quality' in params) ? String(params?.quality) : undefined,
		w: (params && 'width' in params) ? String(params?.width) : undefined,
		variant: (params && 'variant' in params) ? params?.variant : undefined,
	});

	// remove empty fields
	Object.keys(res).forEach((k) => res[k] == null && delete res[k]);

	return new URLSearchParams(res).toString();
};

export const getPublicFileUrl = (fileId: string, params?: PublicFileUrlParams): string =>
	`${PUBLIC_FILE_PATH}${fileId?.startsWith('/') || PUBLIC_FILE_PATH.endsWith('/') ? '' : '/'}${fileId}?${getPublicFileQueryParams(params)}`;
